
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Aviso from './components/AvisoDePrivacidad';
import PaseMedicoPage from './components/PaseMedicoPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aviso-privacidad" element={ <Aviso />} />
        <Route path="/pase-medico" element={ <PaseMedicoPage /> } />
        {/* Agrega más rutas según tus necesidades */}
      </Routes>
    </Router>
  );
}

export default App;
